export default "__VITE_ASSET__KxrWS5Ow__"